export const locale = {
  dashboard_origin: "Dashboard",
  menu: "Menu",
  get_menu_again: "Retrieve Menu Again",
  loading_error: {
    title: "Loading Error!",
    message: "There was an error loading the data! Please try again",
    text: "Retry",
  },
  copy_right: {
    year: "1404",
    text1:
      "All material and intellectual rights of this system are reserved and belong to the advertising company",
    text2: "Superior Entrepreneurs",
    text3: "Sepehr Arad. Any copying will result in legal action.",
  },
  user: "Dear User",
  hi: "Hello",
  exit: "Logout",
  go_to_page: "Go to page",
  show: "Show",
  until: "until",
  from: "from",
  page: "Page",
  notes: "Notes",
  created_at: "Creation Date",
  registration: "Register",
  edit_contact: "Edit Contact",
  cancel: "Cancel",
  edit: "Edit",
  delete: "Delete",
  contact_info: "Contact Information",
  add_birthday: "Add Birthday",
  contacts: "Phonebooks",
  last_updated_at: "Last Edited",
  added_to_contact: "Added to contacts",
  contact_registered: "Your contact has not been saved.",
  transaction: "Transaction",
  write_message: "Write Message",
  note_title: "Note Title",
  create_note: "Add Note",
  are_you_sure_to_delete: "Are you sure you want to delete?",
  last_transaction: "Recent Transactions",
  your_balance: "Your Balance",
  no_transaction: "No transactions have been recorded for you yet!",
  increase_balance: "Increase Balance",
  transaction_list: "Transaction List",
  withdraw: "Withdraw Funds",
  decrease: "Withdraw Funds",
  deposit: "Deposit Funds",
  increase: "Deposit Funds",
  charge: "Charge Wallet",
  refund: "Refund",
  save: "Save",
  reload: "Reload List",
  shared: "Shared",
  list: "List",
  single_add: "Add Single",
  mass_add: "Add Bulk",
  excel_add: "Add from Excel",
  added_successfully: "Added successfully",
  error_add_phone: "Error adding number",
  group: {
    add: "Add New Group",
    delete: "Delete Group",
    edit: "Edit Group",
    first: "Please add a new group first.",
  },
  successfully_deleted: "Deleted successfully",
  notification: {
    text: "User Notifications",
    new: "New Message",
    messages: "Messages",
    events: "Events",
    no_new_message: "No new messages!",
    show_all: "Show All",
    no_new_event: "No new events!",
    go_to_user: "Go to User",
    watched: "Viewed",
  },
  locking_for_service: "What service are you looking for?",
  service_name: "Enter the name of the desired service...",
  invite: {
    title: "Introduce the system to your friends.",
    gift: "Gift",
    get: "Receive.",
    phone: "Enter the number.",
    invite: "Invite!",
    got_it: "Got it",
    get_gift: "Receive Gift",
    success: "Your invitation message was sent successfully.",
    wrong_number: "Please enter a valid number.",
  },
  ticker: {
    text: "We are with you at every moment...",
    help: "Register a ticket to contact our support team",
    register: "Register Ticket",
  },
  package: {
    title: "Active Packages",
    no: "You have no active packages.",
    no_limit: "Unlimited Panel",
    day: " days",
    other: " remaining",
    expiration: "Expiry ",
    expired: " Expired ",
  },
  Loading: {
    Waiting: "Please wait",
    Description: "Just a moment",
  },
  Questions: {
    Yes: "Yes",
    No: "No",
  },
  Success: {
    Title: "Successful",
    defaultActionText: "Got it",
  },
  Info: {
    Title: "Information",
    defaultActionText: "Got it",
  },
  Warning: {
    Title: "Warning",
    defaultActionText: "Got it",
  },
  Error: {
    Title: "Error",
    defaultActionText: "Got it",
  },
  Wallet: {
    Title: "Insufficient Balance",
    defaultActionText: "Got it",
  },
  ConnectionLost: {
    Title: "Your internet connection is lost",
    Subtitle: "Please ensure your internet connection",
    Button: "Retry",
  },
  emoji: "Emoji",
  text_suggest_free: "Text Consultant (Free)",
  select_campaign: "Select Campaign",
  short_link: "Short Link",
  text_suggest: "Text Consultant",
  select_emoji: "Select Emoji",
  default_text: "Default Text",
  emoji_group: {
    "Smileys & Emotion": "Smileys & Emotions",
    "People & Body": "People & Body",
    "Animals & Nature": "Animals & Nature",
    "Food & Drink": "Food & Drink",
    "Travel & Places": "Travel & Places",
    Activities: "Activities",
    Objects: "Objects",
    Symbols: "Symbols",
    Flags: "Flags",
  },
  table: {
    index: "Row",
    title: "Title",
    text: "Text",
    select: "Select",
    next: "Next",
    previous: "Previous",
    rows_per_page: "Rows per page",
    no_data: "No data to display",
    search_placeholder: "Search",
  },
  modal: {
    success: "Success",
  },
  actions: {
    remove: "Remove",
    copyLink: "Copy Link",
    operations: "Operations",
    edit: "Edit",
    delete: "Delete",
    show: "Show",
    accept: "Approve",
    reject: "Reject",
    enable: "Enable",
    download: "Download",
    deactive: "Deactivate",
  },

  shortLink: {
    freeShorten: 'Shorten your links "for free".',
    clickToSelect: "Click on the desired link to select it.",
    create: "Create Short Link",
    title: "Title",
    titleHint: "Please add a name for your short link.",
    link: "Link",
    linkHint: "Enter your desired link.",
    shortenedLink: "Shortened Link",
    clickCount: "Click Count",
    selectDomain: "Select Domain",
  },
  pagination: {
    next: "Next",
    previous: "Previous",
    rowsPerPage: "Rows per page",
    noData: "No data to display",
    search: "Search",
  },
  validation: {
    titleRequired: "Title is required",
    minLength4: "Minimum 4 characters allowed",
    linkRequired: "Link is required",
    mustIncludeHttps: "Must include https://",
    invalidLink: "Please enter a valid link.",
  },
  messages: {
    addedSuccessfully: "Added successfully.",
    confirmDeleteShortLink: "Confirm deletion of short link?",
  },
  inputMenu: {
    text: "Text",
    selectUserInfo: "Select User Details",
  },
  patternDialog: {
    title: "Select Pattern/Campaign",
    change: "Change Pattern/Campaign",
    createPattern: "Register New Pattern",
    createCampaign: "Register New Campaign",
    tabs: {
      pattern: "Select Pattern",
      campaign: "Select Campaign",
    },
    empty: "No pattern found, please register a pattern first.",
    columns: {
      id: "ID",
      type: "Type",
      pattern: "Pattern",
      static: "Static",
      title: "Title",
      content: "Text",
      status: "Status",
      rejected: "Rejected",
      approved: "Approved",
    },
    pagination: {
      next: "Next",
      prev: "Previous",
      rowsPerPage: "Rows per page",
      noData: "No data to display",
      search: "Search",
    },
  },
  PATTERN: {
    SELECTED_MESSAGE: "Selected Message:",
    REQUIRED_INPUTS: "Required Inputs:",
    SELECTED_CAMPAIGN: "Selected Campaign:",
    CAMPAIGN_ID: "ID",
    PRE_NAME: "Prefix",
    NAME: "Name",
    MIDDLE_NAME: "Middle Name",
    LAST_NAME: "Last Name",
    POST_NAME: "Suffix",
    ALIAS: "Alias",
    COMPANY: "Company",
    JOB_TITLE: "Job Title",
    PHONE: "Phone Number",
    BIRTHDAY: "Birthday",
    DESCRIPTION: "Description",
  },
  CONTACT_GROUP: {
    LIST: "List",
    ADD: "Add",
    SEARCH: "Search",
    INDEX: "Row",
    ID: "ID",
    GROUP_NAME: "Group Name",
    PARENT: "Parent",
    CREATE: {
      GROUP_NAME: "Default Group Name",
      PARENT_CATEGORY: "Parent Category",
      ADD_GROUP: "Add Group",
      SUCCESS: "Default group added successfully.",
      ERROR: "Error adding default group!",
      SEARCH: "Search",
      TITLE: "Title",
      SEARCH_IN_TITLE: "Search in Title",
      FROM: "From",
      TO: "To",
      BIRTHDAY_FROM: "Birthday From",
      BIRTHDAY_TO: "To Date",
      ITEMS_PER_PAGE: "Items per page",
      PHONE_COPY: "Copy Number",
      COPY_PHONE: "Copy Number",
      DELETE_CONTACT_GROUP: "Remove Contact from Group",
      DELETE_FROM_GROUP_ONLY: "Remove contact from this group only",
      DELETE_FROM_ALL_GROUPS: "Remove contact from all groups",
      USER: "User",
      PHOTO: "Photo",
      FULL_NAME: "Full Name",
      EMAIL: "Email",
      PHONE_NUMBER: "Cell Number",
      JOB_TITLE_COMPANY: "Job Title and Company",
      CREATED_AT: "Creation Time",
      PHONEBOOK: "Phonebook",
      ACTIONS: "Actions",
    },
    TITLE: "Title",
    SEARCH_IN_TITLE: "Search in Title",
    FROM: "From",
    TO: "To",
    BIRTHDAY_FROM: "Birthday From",
    BIRTHDAY_TO: "To Date",
    ITEMS_PER_PAGE: "Items per page",
    PHONE_COPY: "Copy Number",
    COPY_PHONE: "Copy Number",
    DELETE_CONTACT_GROUP: "Remove Contact from Group",
    DELETE_FROM_GROUP_ONLY: "Remove contact from this group only",
    DELETE_FROM_ALL_GROUPS: "Remove contact from all groups",
    USER: "User",
    PHOTO: "Photo",
    FULL_NAME: "Full Name",
    EMAIL: "Email",
    PHONE_NUMBER: "Cell Number",
    JOB_TITLE_COMPANY: "Job Title and Company",
    CREATED_AT: "Creation Time",
    PHONEBOOK: "Phonebook",
    ACTIONS: "Actions",
  },
  GRADUAL: {
    SEND_GRADUAL: "Gradual Send",
    ALLOWED_HINT: "For sending to more than 500 numbers",
    SEND_GRADUAL_OPTION: "Send gradually",
    AFTER_EVERY: "After every",
    SEND_SMS: "messages should be sent?",
    TIME_INTERVAL: "Time Interval",
    SMS_PART: "Message Count",
    SMS_PART_HINT: "Enter the number of messages per batch.",
    COUNT_ERROR: "Message count per batch cannot be less than 500!",
  },
  HISTORY: {
    CREATE_NEW: "Create New History",
    BACK: "Back",
    TITLE: "History Title",
    STEP: "Step",
    LAST_CALL: "Last Call Time",
    DISCUSSIONS: "Discussions Held",
    REMIND_DATE: "Reminder Time",
    FOLLOWUP: "Follow-up Items for Next Call",
    SAVE_HISTORY: "Save History",
    INDEX: "Row",
    SAVED_BY: "Recorder",
    ACTION: "Management",
    MORE_INFO: "More Information About",
    CREATE_ERROR: "Error adding customer history!",
  },
  FORMS: {
    SourceNumber: "Source Number",
    DestinationPhone: "Destination Number",
    Add: "Add",
    SEND_TO_SELECTED_NUMBERS: "Send to Selected Numbers",
    CHANGE_PATTERN_CAMPAIGN: "Change Pattern/Campaign",
    SendTime: "Send Time",
    SELECTED_MESSAGE: "Selected Message",
    REQUIRED_INPUTS: "Required Inputs",
    SELECTED: "Selected",
    ID: "ID",
    SEND: "Send",
    DATE_REQUIRED: "Date selection is required.",
    TIME_INTERVAL: "Time Interval",
    TIME_INTERVAL_FROM_PREVIOUS: "Time Interval from Previous Message",
    Title: "Title",
    LINK: "Link",
    LINK_HINT: "any",
    LINK_PLACEHOLDER: "Example:[](https://example.ex/any)",
    LINK_SHORTENED_HINT:
      "Your link will be shortened to 14 characters and replaced in the text (example.ex/any), with a unique link for each message.",
    Text: "Text",
    MUST_INCLUDE_PATTERN: "Must include the phrase {pattern}",
    INVALID_LINK: "Enter a valid link",
  },
  ERRORS: {
    VpnDetectedTitle: "Turn off your VPN",
    VpnDetectedSubtitle:
      "This will help the system work better and give you a smoother experience.",
    PhoneIsNotValid: "Phone number is not valid",
    MaxPhoneLimit: "You cannot add more than 50,000 numbers.",
    NoSelectedLineNumber: "No source number selected.",
    INVALID_TIMER: "Enter a valid time",
    NoAccess: "You do not have access",
    PleaseBuyAPlane: "Please purchase a plan",
    NoAccountCharge: "Insufficient account balance",
    PleaseChargeYourAccount: "Please charge your account",
    Unauthorized: "Access denied: Please log in again",
    ServerError: "Server error occurred, please try again later",
    NetworkError: "Network error: Please check your internet connection",
    InvalidInput: "Invalid input",
    SessionExpired: "Your session has expired, please log in again",
    TokenInvalid: "Invalid token",
    VpnDetected: "Your VPN is active, please turn it off",
    RequestTimeout: "Your request timed out, please try again",
    DuplicateEntry: "This item is already registered",
  },

  BUTTONS: {
    DELETE_NUMBERS: "Delete Numbers",
    ADD_BULK: "Add Bulk",
    FROM_FILE: "From File",
    More: "More",
    BuyAPlane: "Purchase Plan",
    AccountCharge: "Charge Account",
    OK: "OK",
    Close: "Close",
    Cancel: "Cancel",
    Retry: "Retry",
    Login: "Login",
    Logout: "Logout",
    Save: "Save",
    Submit: "Submit",
  },
  GENERAL: {
    row: "Row",
    id: "ID",
    back: "Back",
    manage: "Manage",
    SENDING: "Sending",
    RELOAD: "Reload",
    PRINT: "Print",
    DELETE: "Delete",
    SUBMIT: "Submit",
    SUCCESSFULLY_ADDED: "Added successfully",
    CANCEL: "Cancel",
    SUCCESSFULLY_DOWNLOADED: "Downloaded successfully",
    Loading: "Loading...",
    NoData: "No data found",
    Welcome: "Welcome",
    Profile: "Profile",
    Settings: "Settings",
    Wallet: "Wallet",
    Dashboard: "Dashboard",
  },

  NOTICES: {
    Attention: "Please note",
    MinimumSendWarning:
      'When sending SMS with the "News" source number, the minimum count must be {{number}}.',
  },
  contactsTags: {
    select_group: "Select Group",
    create_group: "Create Group",
    search: "Search",
    add_group: "Add Group",
    enter_group_name: "Enter your desired name",
    group_name: "Group Name",
    cancel: "Cancel",
    edit: "Edit",
    save: "Save",
    loading_categories: "Loading categories...",
    select_group_and_subgroup: "Select Group and Subgroup",
    add_group_with_subgroups: "Add group with subgroups",
    add_group_only: "Add selected group only",
    duplicate_name_error: "Duplicate name",
    added_successfully: "Added successfully.",
    confirm_delete_group: "Confirm group deletion?",
    deleted_successfully: "Deleted successfully",
    edited_successfully: "Edited successfully",
    group_added_successfully: "Selected group(s) added successfully.",
    error_creating_group: "Error creating default group",
    create_default_group: "Create Default Group",
    select_default_group: "Select Default Group",
    add_custom_group: "Add Group with Custom Name",
  },
  CONTACT_SHARE: {
    ADD_PHONE_NUMBER: "Add Phone Number",
    ADD: "Add",
    SHARE_ACCESS:
      "By selecting any of the options below, share the desired access with others.",
    SELECT_ACCESS: "Select Access for Phonebook",
    DELETE: "Delete",
    EDIT: "Edit",
    SEND: "Send",
    PERSONS_WITH_ACCESS: "People with Access",
    REMOVE_ACCESS: "Remove Access",
    RETURN: "Return",
    SAVE_CHANGES: "Save Changes",
    SHARE_CONTACT_BOOK: "Share Phonebook",
    PHONE_VALIDATION: "Enter a valid phone number",
    SUCCESS_SHARE: "Phonebook shared successfully.",
    ERROR_SHARE: "Error sharing phonebook!",
    PHONE_DUPLICATE: "Number already entered!",
    CHANGES_SAVED: "Changes saved successfully.",
    ERROR_SAVING_CHANGES: "Error saving changes!",
  },
  CONTACT_SEARCH: {
    SEARCH: "Search",
    ADD_NUMBER: "Add Number",
  },
  CONTACT_PAGINATION: {
    PER_PAGE: "Per Page",
    FROM: "From",
    TO: "To",
    TOTAL: "Total",
  },
  SUCCESS: {
    DELETED: "Deleted successfully",
    SUCCESS: "Success",
  },
  CONFIRM: {
    DELETE_BULK: "Delete unsaved numbers?",
  },
  TOOLTIP: {
    CopyPhoneNumbers: "Copy your numbers and then click",
    COPY_LINK: "Copy Link",
    COPY_NUMBER: "Copy Number",
    SEE_PROFILE: "View Profile",
  },
  CONTACT_EDIT: {
    EDIT: "Edit",
    DELETE: "Delete",
  },
  CONTACT_MENU: {
    SHARE: "Share",
    PRINT: "Print",
    EXCEL_EXPORT: "Export to Excel",
    DELETE: "Delete",
    SUCCESS_DELETE: "Deleted successfully.",
    ERROR_DELETE: "Error deleting contacts!",
  },
  CONTACTS: {
    PREFIX: "Prefix",
    NAME: "Name",
    MIDDLENAME: "Middle Name",
    LASTNAME: "Last Name",
    POSTFIX: "Suffix",
    ALIAS: "Alias",
    COMPANY: "Company",
    JOBTITLE: "Job Title",
    PHONE: "Phone Number",
    PHONE_PLACEHOLDER: "e.g., 8070 111 13 (989)(989+)(9)(09)",
    ADD_EMAIL: "Add Email",
    EMAIL: "Email",
    ADD_ADDRESS: "Add Address",
    ADDRESS: "Address",
    PROVINCE: "Province",
    CITY: "City",
    POSTALCODE: "Zip Code",
    YEAR_OPTIONAL: "Year (optional)",
    MONTH: "Month",
    DAY: "Day",
    ADD_BIRTHDAY: "Add Birthday",
    ADD_WEBSITE: "Add Website",
    WEBSITE: "Website",
    ADD_DATE: "Add Date",
    DATE: "Date",
    CUSTOM_FIELD: "Custom Field",
    ADD_CUSTOM_FIELD: "Add Custom Field",
    NOTE: "Notes",
    ADD_NOTE: "Add Note",
    HOME: "Home",
    WORK: "Work",
    OTHER: "Other",
    PROFILE: "Profile",
    BLOG: "Blog",
    HOMEPAGE: "Homepage",
    TITLE: "Title",
    BIRTHDAY_ERROR: "Enter date correctly",
    YEAR_ERROR: "4 digits",
    EMAIL_ERROR: "Enter email correctly",
    WEBSITE_ERROR: "Enter link correctly (website.com)",
    PHONE_ERROR: "Enter valid phone number",
    ADD_HISTORY: "Add History",
    HISTORY_LIST: "History List",
    EDIT_CONTACT: "Edit Contact",
    SHOW_CONTACT: "Show Contact",
  },
  MONTHS: {
    FARVARDIN: "Farvardin",
    ORDIBEHESHT: "Ordibehesht",
    KHORDAD: "Khordad",
    TIR: "Tir",
    MORDAD: "Mordad",
    SHAHRIVAR: "Shahrivar",
    MEHR: "Mehr",
    ABAN: "Aban",
    AZAR: "Azar",
    DEY: "Dey",
    BAHMAN: "Bahman",
    ESFAND: "Esfand",
  },

  UPLOAD_EXCEL: {
    DOWNLOAD_SAMPLE: "Download and use the sample Excel file",
    UPLOAD_TITLE: "Upload File",
    DRAG_DROP_TEXT_PART1: "Drag and drop to upload or",
    DRAG_DROP_TEXT_PART2: "here",
    DRAG_DROP_TEXT_PART3: "click",
    FILE_INPUT_LABEL: "Upload Excel File",
  },
  SUCCESS_MESSAGE: {
    LINK_COPIED: "Link copied successfully!",
  },
  ERROR_MESSAGE: {
    COPY_LINK_FAILED: "Error copying link.",
  },
  POPUP: {
    TITLE_OR_BUTTON_TEXT: "Select Pattern/Campaign",
    BUTTON_EDIT_TEXT: "Change Pattern/Campaign",
  },
  BUTTON: {
    REGISTER_NEW_PATTERN: "Register New Pattern",
    REGISTER_NEW_CAMPAIGN: "Register New Campaign",
    CREATE_NEW_HISTORY: "Create New History",
    SAVE_HISTORY: "Save History",
    SELECT_GROUP: "Select Group",
    CREATE_GROUP: "Create Group",
    ADD_GROUP: "Add Group",
    SAVE: "Save",
    CREATE_GROUP_SINGULAR: "Create Group",
    ADD: "Add",
    SEND: "Send",
    EDIT_PERMISSIONS: "Edit",
    GO_BACK: "Go Back",
    SAVE_CHANGES: "Save Changes",
    GUIDE: "Guide",
    START: "Start",
    EDIT: "Edit",
    CANCEL: "Cancel",
    AUTO_REFRESH: "Auto Refresh",
    AUTO_REFRESH_SETTINGS: "Auto Refresh Settings",
    BACK: "Back",
  },
  TABS: {
    SELECT_PATTERN: "Select Pattern",
    SELECT_CAMPAIGN: "Select Campaign",
    LIST: "List",
    ADD: "Add",
    ADD_CUSTOM_GROUP: "Add Group with Custom Name",
    SELECT_DEFAULT_GROUP: "Select Default Group",
  },
  NO_DATA: {
    NO_PATTERN: "No pattern found, please register a pattern first.",
  },
  TABLE: {
    ID: "ID",
    TYPE: "Type",
    PATTERN: "Pattern",
    STATIC: "Static",
    TITLE: "Title",
    TEXT: "Text",
    STATUS: "Status",
    REJECTED: "Rejected",
    ACCEPTED: "Approved",
    NEXT_BUTTON: "Next",
    PREVIOUS_BUTTON: "Previous",
    ROWS_PER_PAGE_TEXT: "Rows per page",
    NO_DATA_TEXT: "No data to display",
    PLACEHOLDER_SEARCH: "Search",
    MORE_INFO_ABOUT_ITEM: "More information about {name}",
  },
  MENU_ITEMS: {
    TEXT_INPUT: "Text",
    SELECT_USER_INFO: "Select User Details",
  },
  TABLE_CONTROLS: {
    COUNT: "Count",
    SEARCH: "Search",
  },
  FORM_LABELS: {
    DEFAULT_GROUP_NAME: "Default Group Name",
    PARENT_CATEGORY: "Parent Category",
    HISTORY_TITLE: "History Title",
    STEP: "Step",
    LAST_CALL_TIME: "Last Call Time",
    NEGOTIATIONS: "Negotiations Held",
    REMINDER_TIME: "Reminder Time",
    FOLLOW_UP_ITEMS: "Follow-up Items for Next Call",
    GROUP_NAME: "Group Name",
    SEARCH: "Search",
    TITLE: "Title",
    SEARCH_IN_TITLE: "Search in Title",
    FROM: "From",
    TO: "To",
    BIRTHDAY_FROM: "Birthday From",
    BIRTHDAY_TO: "To Date",
    COUNT: "Count",
    ADD_PHONE_NUMBER: "Add Phone Number",
  },
  TOAST: {
    Success: "Operation completed successfully",
    Error: "An error occurred",
    Warning: "Warning: Please check inputs",
    AUTO_REFRESH_STARTED: "Auto refresh started.",
    DEFAULT_GROUP_SUCCESS: "Default group added successfully.",
    DEFAULT_GROUP_ERROR: "Error adding default group!",
    ADD_HISTORY_ERROR: "Error adding customer history!",
    DUPLICATE_NAME: "Duplicate name",
    TAG_ADDED_SUCCESS: "Tag added successfully.",
    TAG_DELETED_SUCCESS: "Tag deleted successfully",
    TAG_EDITED_SUCCESS: "Tag edited successfully",
    GROUPS_ADDED_SUCCESS: "Selected group(s) added successfully.",
    ADD_GROUP_ERROR: "Error adding default group!",
    PHONE_COPIED_SUCCESS: "Cell number copied.",
    SUCCESSFULLY_DELETED: "Deleted successfully",
    ERROR_DELETING_CONTACT_FROM_PHONEBOOK:
      "Error deleting contact from phonebook!",
    SHARE_SUCCESS: "Phonebook shared successfully.",
    SHARE_ERROR: "Error sharing phonebook!",
    NUMBER_ALREADY_ADDED: "Number already entered!",
    CHANGES_SAVED_SUCCESS: "Changes saved successfully.",
    CHANGES_SAVE_ERROR: "Error saving changes!",
  },
  HEADERS: {
    GRADUAL_SEND: "Gradual Send",
    GRADUAL_SEND_HINT: "(For sending to more than 500 numbers)",
  },
  CHECKBOX_LABELS: {
    GRADUAL_SENDING: "Send gradually",
    DELETE: "Delete",
    EDIT: "Edit",
    ADD: "Add",
  },
  MESSAGES: {
    SENDING_INTERVAL_QUESTION: "After every {time} messages should be sent?",
  },
  LABELS: {
    TIME_INTERVAL: "Time Interval",
    MESSAGE_COUNT: "Message Count",
  },
  TIME_TYPES: {
    MINUTE: "Minute",
    HOUR: "Hour",
    DAY: "Day",
    WEEK: "Week",
    SECOND: "Second",
  },
  HINTS: {
    MESSAGE_COUNT_PER_PART: "Enter the number of messages per batch.",
  },
  RULES: {
    MESSAGE_COUNT_MIN_LIMIT: "Message count per batch cannot be less than 500!",
  },
  TABLE_HEADERS: {
    ROW: "Row",
    TITLE: "Title",
    STEP: "Step",
    REMINDER_TIME: "Reminder Time",
    LAST_CALL_TIME: "Last Call Time",
    RECORDER: "Recorder",
    MANAGEMENT: "Management",
    ID: "ID",
    GROUP_NAME: "Group Name",
    PARENT: "Parent",
    CREATED_AT: "Created",
    IMAGE: "Image",
    FULL_NAME: "Full Name",
    EMAIL: "Email",
    PHONE_NUMBER: "Cell Number",
    JOB_COMPANY: "Job Title and Company",
    CREATION_TIME: "Creation Time",
    PHONEBOOK: "Phonebook",
    ACTIONS: "Actions",
    USER: "User",
  },
  PROPS: {
    SOURCE_NUMBER_LABEL: "Source Number",
  },
  MODAL: {
    INFO_TITLE: "Please note.",
    INFO_MESSAGE_NEWS_NUMBER:
      'When sending SMS with source number "{number}", the minimum count must be 1000.',
    CONFIRM_DELETE_GROUP: "Confirm group deletion?",
  },
  SPECIAL_NUMBERS: {
    NEWS_SEND: "News Send",
  },
  POPUP_TITLES: {
    SYSTEM_GUIDE: "System Guide",
    ERROR: "Error",
    WARNING: "Warning",
    SUCCESS: "Success",
    CONFIRM: "Confirm",
    SELECT_GROUP: "Select Group",
    CREATE_NEW_GROUP: "Create New Group",
    SELECT_GROUP_SUBGROUP: "Select Group and Subgroup",
    CREATE_DEFAULT_GROUP: "Create Default Group",
    DELETE_CONTACT_FROM_GROUP: "Remove Contact from Group",
    DELETE_CONTACT: "Delete Contact",
    SHARE_PHONEBOOK: "Share Phonebook",
    SYSTEM_GUIDE: "Terminal Ads System Guide",
  },
  CARD_TITLES: {
    ENTER_GROUP_NAME: "Enter your desired name",
    SELECT_PERMISSIONS: "Select Access for Phonebook {name}:",
    PEOPLE_WITH_ACCESS: "People with Access",
  },
  LOADING_MESSAGES: {
    FETCHING_CATEGORIES: "Loading categories...",
  },
  RADIO_LABELS: {
    GROUP_WITH_SUBGROUPS: "Add group with subgroups",
    SELECTED_GROUP_ONLY: "Add selected group only",
    DELETE_FROM_THIS_GROUP_ONLY: "Remove contact from this group only",
    DELETE_FROM_ALL_GROUPS: "Remove contact from all groups",
  },
  FILTER_LABELS: {
    ADDRESS: "Address",
    EMAIL: "Email",
    WEBSITE: "Website",
    CUSTOM_FIELD: "Custom Field",
    DATE: "Date",
  },
  CARD_SUBTITLES: {
    SHARE_INSTRUCTION:
      "By selecting any of the options below, share the desired access with others.",
  },
  VALIDATION: {
    INVALID_PHONE_NUMBER: "Enter a valid phone number",
  },
  LIST_ITEM_TITLES: {
    DELETE: "Delete",
    EDIT: "Edit",
    ADD: "Add",
    REMOVE_ACCESS: "Remove Access",
  },
  CAMPAIGN: {
    CAMPAIGN_NAME: "Campaign Name",
    TEXT: "Text",
    MESSAGE: "Message",
    FOR: "For",
    SELECT_CAMPAIGN: "Select Campaign",
    CLICK_ROW: "Click on the desired row.",
    NEW: "New",
    SUBMIT_CAMPAIGN: "Register Campaign",
    TIME: "Time",
    MESSAGE_COUNT: "Message Count",
    PAGE_COUNT: "Total Messages (Pages)",
    PAGE: "Page",
    CANCEL_TEXT: "Cancel11",
    TRACKABLE_LINK: "Trackable Link",
    WARNING_TEXT: "Please correct the text(s) of the selected campaign!",
    WARNING_TITLE: "Please correct the title(s) of the selected campaign!",
    WARNING_GAP:
      "Please correct the time interval(s) of the selected campaign!",
    WARNING_OPERATOR:
      "Please correct the operator(s) of the selected campaign!",
    MAX_ITEMS_ERROR: "Maximum 10 items can be added.",
  },
  ADS: {
    LIVE_SMS: "Live SMS Send",
    BUY_JOB_DB: "Purchase Business Database",
    SMART_LADDER: "Smart Divar Ad Ladder",
    JOB_SMS: "Send SMS to Businesses",
    WEB_DESIGN: "Order Website Design",
    SEO: "Order SEO",
    MAP_SMS: "Send SMS from Map",
    GRADUAL_LADDER: "Gradual Divar Ad Ladder",
    SEO_ALT: "Order SEO",
    SITE_SUPPORT: "Website Management and Support",
    CITY_SMS: "Send SMS to City and Province",
    AUTO_CHAT: "Divar Auto Chat",
  },
  TUTORIALS: {
    WHATSAPP_SUPPORT: "WhatsApp Support",
    TICKET_SUPPORT: "Register Ticket",
  },
  INCREASE: {
    PAN: "Card Number",
    CVV2: "CVV2",
    MONTH: "Month",
    YEAR: "Year",
    PIN2: "Second Password",
    GET_OTP: "Receive OTP",
    PAY: "Pay",
    INVALID_PAN: "Card number is incorrect",
    INVALID_CVV2: "CVV2 is incorrect",
  },
  WALLET: {
    CustomCharge: "Charge Wallet",
    withdrawTitle: "Withdraw from Wallet",
    transactionListTooltip: "Your transaction list",
    reloadTooltip: "Reload",
    withdrawTooltip: "Withdraw from Wallet",
    AmountLabel: "Credit ",
    SelectAmount: "Select Amount",
    Amount: "Amount",
    Currency: "Rial",
    GateWay: "Payment Gateway",
    noGateWay: "No gateway found",
    Pay: "Pay",
    PriceNotInRange: "Amount must be between {min} and {max}.",
    ErrorOnRedirectToGateWay: "Error redirecting to payment gateway",
    ErrorGeneral: "Error",
    MinAmountError: "Entered amount is less than the minimum allowed.",
    MinBazarAmountError: "Amount cannot be less than 10,000 Tomans!",
    BazarSuccessInfo:
      "In case of successful payment, it takes 1 to 3 minutes for your wallet to be charged.",
    withdrawableBalance: "Withdrawable Balance",
    withdrawFee: "Withdrawal fee: 50,000 Rials!",
    selectAccount: "Select Account",
    addAccount: "Add Account",
    submitWithdraw: "Submit Withdrawal",
    accountRequiredInfo: "All information is required.",
    ownerName: "Account Owner Name",
    ownerLastName: "Last Name",
    bankName: "Bank Name",
    accountNumber: "Account Number",
    cardNumber: "Card Number",
    sheba: "Sheba Number",
    onlyPersian: "Only Persian letters allowed!",
    cardNumberLength: "Card number must be 16 digits!",
    shebaLength: "Sheba number must be 24 digits!",
  },
  USER_PICKER: {
    SELECT_USER: "Select User",
    SELECT_USERS: "Select Users",
    SEARCH: "Search",
    PERSON: "Individual",
    COMPANY: "Legal Entity",
    ID: "ID",
    NAME: "Name",
    LASTNAME: "Last Name",
    USERNAME: "Username",
    PHONE: "Cell Number",
    TYPE: "User Type",
  },
  NEWS: {
    TITLE: "SMS Land News",
    VIEW_BUTTON: "View",
    NO_NEWS: "No fresh news.",
    FETCH_ERROR: "Error fetching news!",
  },
  MENUS: {
    CONTACT_LIST: "Contact List",
    FINDPREFIX: "Search Prefix",
    // Systems
    TICKET_REGISTRATION: "Register Ticket",
    AD_TERMINAL_SYSTEM: "Terminal Ads System",
    WALLET_TRANSACTIONS: "Wallet Transactions",
    DYNAMIC_QR_SYSTEM: "Dynamic QR Creation System",
    DIVAR_AD_SYSTEM: "Divar Ad Submission and Management System",
    GRAPHIC_DESIGN_SYSTEM: "Graphic Design and Print Order System",
    DIGITAL_MARKETING_SYSTEM: "Digital Marketing Management System",
    BULK_SMS_SYSTEM: "Bulk SMS System",
    BUSINESS_INFO_SYSTEM: "National Business Information Database System",
    AD_MANAGEMENT_SYSTEM: "Ad Management System",
    GRAPHIC_VIDEO_SERVICES: "Graphic and Video Design Services System",
    // QR Tools
    QR_TOOL: "QR Tools",
    CREATE_DYNAMIC_QR: "Create Dynamic QR",
    QR_MANAGEMENT: "QR Management",
    QR_MONITORING: "QR Monitoring",
    MY_QR_LIST: "My QR List",
    PHYSICAL_NFC_ORDERS: "Physical Card and NFC Orders",
    BULK_QR_GENERATION: "Bulk QR Code Generation",
    IMAGE_CREATION_TOKEN: "Image Creation Token",
    QR_SMS: "QR SMS",
    QR_LINK: "QR Link",
    QR_TEXT: "QR Text",
    QR_LOCATION: "QR Location",
    QR_EMAIL: "QR Email",
    QR_CALL: "QR Call",
    QR_WIFI: "QR WiFi",
    VISIT_STATISTICS: "Visit Statistics",
    // Ad Management
    AD_MONITORING: "Ad Monitoring",
    DIVAR_NEWS: "Divar Updates",
    REAL_ESTATE_AD_SUBMISSION: "Real Estate Panel Ad Submission",
    AUTO_AD_RENEWAL: "Auto Ad Renewal",
    GRADUAL_AD_SUBMISSION: "Gradual Ad Submission",
    SMART_AD_SUBMISSION: "Smart Ad Submission",
    DEFAULT_AD_REGISTRATION: "Default Ad Registration",
    AD_ANALYZER: "Ad Visit Analyzer",
    ADD_AD_PHOTO: "Add Ad Photo",
    SMART_LADDER: "Smart Ladder",
    GRADUAL_LADDER: "Gradual Ladder",
    ADS_LIST: "Ad List",
    AD_REPORTS: "Ad Reports",
    SCHEDULED_AD_SUBMISSION: "Scheduled Ad Submission",
    SCHEDULED_AD_LIST: "Scheduled Ad List",
    PERSONAL_AD_SUBMISSION: "Personal Ad Submission",
    TARGET_TOOLS: "Targeted Tools",
    SMART_LIST: "Smart/Gradual List",
    // SMS
    SEND_TO_CUSTOMER_CLUB: "Send to Customer Club",
    BULK_SMS: "Bulk SMS",
    LIVE_SMS: "Live SMS (Old)",
    SEND_TO_BUSINESSES: "Send to National Businesses",
    SMS_BY_MAP: "SMS from Map",
    CITY_PROVINCE_SMS: "City and Province SMS",
    RECEIVED_SMS_LIST: "Received SMS List",
    SMS_TEXT_CONSULTANT: "SMS Text Consultant Monitor",
    DEFAULT_TEXT_CONSULTATION: "Default Text + Consultation",
    ADMIN_SMS_SUBMISSIONS: "Admin Submissions",
    PENDING_SMS: "Pending SMS",
    ADMIN_RECEIVED_REPORT: "Admin Received Report",
    PATTERN: "Pattern/Template",
    SMS_REPORTS: "Submission Reports",
    DEDICATED_LINE_REQUESTS: "Dedicated Line Requests",
    PHONEBOOK: "Phonebook",
    SMS_TARIFFS: "SMS Tariffs",
    LINE_CATEGORIES: "Line Categories",
    TARIFF_COEFFICIENTS: "Tariff Coefficients",
    SEND_ADMIN_SMS: "Send Admin SMS",
    // Numbers and Contacts
    ADD_NEW_NUMBER: "Add New Number",
    NUMBERS: "Numbers",
    USER_NUMBERS: "User Numbers",
    REGISTER_USER_NUMBER: "Register Number for User",
    NUMBER_LIST: "My Number List",
    CREATE_NUMBER_TARIFF: "Create Number Tariff",
    NUMBER_TARIFF_LIST: "Number Tariff List",
    OTHER_TARIFF_LIST: "Other Tariff List",
    // Financial Management
    WALLET: "New Wallet",
    TRANSFER_REQUESTS: "Withdrawal Requests",
    DIVAR_PAYMENTS: "Divar Payments",
    AUTO_PAYMENT: "Auto Payment",
    PAYMENTS: "Payments",
    PAYMENT_GATEWAY: "Payment Gateway",
    BUY_CHARGE: "Purchase Charge",
    // Customer and User Management
    CUSTOMERS: "Customers",
    CRM_CUSTOMERS: "CRM Customers",
    CONTACT_LIST: "Contact Assistant (Thank You for Calling)",
    USERS: "User List",
    USER_REQUESTS: "User Requests",
    PROFILE: "Profile",
    USER_HISTORY_NOTIFICATIONS: "User History Notifications",
    // Design and Content
    WEBSITE_DESIGN_ORDER: "Website Design Order",
    SEO_ORDER: "SEO Order",
    BUY_INFO_DATABASE: "Purchase Information Database",
    BUY_MOBILE_DATABASE: "Purchase Cell Database",
    PURCHASED_ARCHIVES: "Purchased Archives",
    FAVORITE_ARCHIVES: "Favorite Archives",
    UPLOAD_CENTER: "Upload Center",
    CONTENT: "Content",
    // Management and Settings
    MONITORING: "Monitoring",
    MANAGEMENT: "Management",
    SETTINGS: "Settings",
    CATEGORIES: "Categories",
    DOMAINS: "Domains",
    REMINDERS: "Reminders",
    AUTOMATIC_CREATION: "Automatic Creation",
    PERMISSIONS: "Permissions",
    ROLES: "Roles",
    MENUS: "Menus",
    CORE_MANAGEMENT: "Core Management",
    WORK_REPORTS: "Work Reports Management",
    WORK_REPORT_CREATE: "Work Report",
    DEPARTMENTS: "Departments",
    DISCOUNTS: "Discounts",
    NOTIFICATIONS: "Notifications",
    ADMIN_NOTIFICATIONS: "Admin Notifications",
    TICKET_MANAGEMENT: "Ticket Management",
    USER_GUIDE: "User Guide",
    CAMPAIGN: "Campaign",
    MESSAGE_CATEGORIES: "Message Categories",
    REGISTERED_INFO_LIST: "Registered Information List",
    TARIFFS: "Tariffs",
    INFORMATION_REGISTRATION: "Information Registration",
    UNCREATED_CARDS: "Uncreated Cards",
    MODELS_LIST: "Model List",
    CREATE_DEFAULT_PRODUCT: "Create Default Product",
    EXCEL_FILES: "Excel Files",
    AUTO_CHATS: "Smart Chat",
    AUTO_CHAT: "Auto Chat",
    // Other
    MY_FILES: "My Files",
    CONSULTANTS: "Consultants",
    ADD_DIVAR_NEWS: "Add Divar Updates",
    BUY_PANEL: "Purchase Panel",
    PANELS: "Panels",
    CALL_MONITORING: "Call Monitoring",
    INFO_REVIEW: "Information Review",
    MESSAGES: "Messages",
    PERSONNEL: "Personnel",
    //qr
    QR_TOOL: "QR Tools",
    CREATE_DYNAMIC_QR: "Create Dynamic QR",
    QR_MANAGEMENT: "QR Management",
    QR_MONITORING: "QR Monitoring",
    MY_QR_LIST: "My QR List",
    PHYSICAL_NFC_ORDERS: "Physical Card and NFC Orders",
    BULK_QR_GENERATION: "Bulk QR Code Generation",
    IMAGE_CREATION_TOKEN: "Image Creation Token",
    CATEGORIES: "Categories",
    CREATE_DEFAULT_PRODUCT: "Create Default Product",
    DOMAINS: "Domains",
    REMINDERS: "Reminders",
    AUTOMATIC_CREATION: "Automatic Creation",
    SEND_ADMIN_SMS: "Send Admin SMS",
    UNCREATED_CARDS: "Uncreated Cards",
    MODELS_LIST: "Model List",
    UPLOAD_CENTER: "Upload Center",
    INFORMATION_REGISTRATION: "Information Registration",
    TARIFFS: "Tariffs",
    REGISTERED_INFO_LIST: "Registered Information List",
    //code
    personel: "Personnel",
    "workReports/create": "Work Report",
    "admin/user-guide": "User Guide",
    phonebook: "Customer Club",
    contactlist: "Contact Assistant (Thank You for Calling)",
    "contact/list": "Contact Assistant (Thank You for Calling)",
    "admin/transferRequests": "Withdrawal Requests",
    "admin/wallet": "New Wallet",
    "admin/cdr": "Call Monitoring",
    "admin/campaign": "Campaign",
    "admin/message-categories": "Message Categories",
    "admin/customers": "CRM Customers",
    "admin/notifications": "Admin Notifications",
    "admin/user-history/notifications": "User History Notifications",
    "admin/messages": "Messages",
    profile: "Profile",
    "admin/workReports": "Work Reports Management",
    panel: "Purchase Panel",
    adminDiscounts: "Discounts",
    departments: "Departments",
    adminTickets: "Ticket Management",
    "admin/configs": "Settings",
    notifications: "Notifications",
    "user/confirmed": "User Requests",
    users: "User List",
    payments: "Payment Gateway",
    permission: "Permissions",
    panels: "Panels",
    category: "Menus",
    content: "Content",
    role: "Roles",
    "core/admin": "Core Management",
    //robot
    numberList: "My Number List",
    registerAd: "Register Ad",
    proPanelSendAd: "Professional Panel Ad Submission",
    buyCharge: "Purchase Charge",
    scheduledAdSend: "Scheduled Ad Submission",
    smartGradual: "Smart/Gradual",
    createNumberTariff: "Create Number Tariff",
    numberTariffList: "Number Tariff List",
    otherTariffList: "Other Tariff List",
    userNumbers: "User Numbers",
    numbers: "Numbers",
    management: "Management",
    settings: "Settings",
    registerUserNumber: "Register Number for User",
    divarPayments: "Divar Payments",
    autoPayment: "Auto Payment",
    adAnalyzer: "Ad Visit Analyzer",
    infoReview: "Information Review",
    rb_payments: "Payments",
    autoChat: "Auto Chat",
    ads: "Ads",
    monitoring: "Monitoring",
    smartLadder: "Smart Ladder",
    gradualLadder: "Gradual Ladder",
    excelFiles: "Excel Files",
    autoChats: "Smart Chat",
    addAdPhoto: "Add Ad Photo",
    targetTools: "Targeted Tools",
    smartList: "Smart/Gradual List",
    scheduledAdList: "Scheduled Ad List",
    adsList: "Ad List",
    adReports: "Ad Reports",
    personalAdSend: "Personal Ad Submission",
  },
  AUTO_REFRESH_POPUP: {
    TITLE: "Enter your desired time:",
    SUBTITLE:
      "After setting the time, this page will always refresh at the selected interval.",
    TIME_LABEL: "Time",
  },
  MODAL: {
    OK_TITLE: "Confirm",
  },

  ROUTE: {
    TITLES: {
      QR_LUCK_WHEEL_Edit: "Edit Luck Wheel",
      QR_LUCK_WHEEL: "Create QR Spin-the-Wheel",
      DASHBOARD: "Dashboard",
      ADMIN_QR_DOMAINS: "Domain Monitoring",
      ADMIN_TOGETHER_TOKEN: "Token Monitoring",
      ADMIN_QR_SMS: "Send SMS",
      MENU_PROFILE_INFO: "User Information",
      MENU_PROFILE_SETTING: "Profile Settings",
      MENU_PROFILE_ORDERS: "Orders",
      MENU_PROFILE_ADDRESSES: "Addresses",
      QR_MONITORING: "QR Monitoring",
      QR_LIST: "My QR List",
      QR_NAME_LIST: "Participation Management",
      QR_GENERATE_MULTIPLE: "Bulk QR Code Generation",
      QR_CARD_VISIT: "Create Business Card",
      HELP_INFO: "Test Button",
      QR_MENU: "Shop Menu",
      QR_APPOINTMENT: "Appointment Booking",
      QR_INSURANCE: "Create Online Insurance",
      QR_BPAGE: "Create Business Page",
      QR_CPAGE: "Create Commercial/Administrative Complex Site",
      QR_BSHOP: "Online Shop",
      QR_NAME_EDIT_BSHOP: "Edit Online Shop",
      QR_LINK_EDIT: "Edit Link",
      QR_NAME_DESIGN: "Edit Design",
      QR_NAME_SETTING: "Edit Settings",
      QR_NAME_EDIT: "Edit Business Card",
      QR_NAME_EDIT_BPAGE: "Edit Business Page",
      QR_EDIT_CPAGE: "Edit Commercial/Administrative Complex Site",
      QR_NAME_INSURANCE: "Edit Online Insurance",
      QR_NAME_EDIT_MENU: "Edit Menu",
      QR_NAME_EDIT_APPLICATION: "Provide Application",
      QR_NAME_EDIT_APPOINTMENT: "Edit Appointment Booking",
      QR_NAME_EDIT_PHOTO: "Edit Photo Gallery",
      QR_NAME_EDIT_VIDEO: "Edit Video Gallery",
      QR_NAME_EDIT_VOICE: "Edit Audio Gallery",
      QR_NAME_EDIT_FEEDBACK: "Edit Feedback Gallery",
      QR_NAME_CONSULTATION_QR_EDIT: "Edit Request Form",
      QR_NAME_EDIT_VOICE_PRO: "Edit Audio Gallery (Pro)",
      QR_NAME_EDIT_SOCIAL: "Edit Social Networks",
      QR_NAME_STATISTICS: "QR Code Statistics",
      QR_CATE: "Select Category",
      QR_SHARE: "Share",
      QR_BUSINESS_SHOP: "Business/Shop",
      QR_CO_ORGAN: "Corporate/Organizational",
      QR_CONTACT: "Customer Contact",
      QR_NOTICES: "Notifications",
      QR_OTHERS: "Miscellaneous",
      QR_STATICS: "Static QR",
      QR_DYNAMICS: "Dynamic QR",
      QR_D_BUSINESS: "Dynamic Business QR",
      QR_D_ORGANS: "Dynamic Organizational QR",
      QR_D_GOVERNMENT: "Dynamic Government QR",
      QR_VIDEO: "Video Gallery",
      QR_APPLICATION: "Provide Application",
      QR_VOICE: "Audio Gallery",
      QR_VOICE_PRO: "Audio Gallery (Pro)",
      QR_CONSULTATION_QR: "Request Form",
      QR_FEEDBACK: "Feedback Gallery",
      QR_PHOTO: "Photo Gallery",
      QR_CATALOG: "Catalog / Brochure",
      QR_LOCATION: "Create Location QR",
      QR_SOCIAL_MEDIA: "Create Social Media QR",
      QR_LINK: "Create Link",
      QR_TEXT: "Create Text",
      QR_MAIL: "Create Email",
      QR_CALL: "Call",
      QR_SMS: "SMS",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "Website",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "WiFi",
      QR_BUSINESS: "Business Page",
      QR_DISCOUNT: "Discount Page",
      QR_PRODUCT_SHOP: "Product Introduction",
      QR_PRODUCT_LABEL: "Product Label",
      QR_GOLD_LABEL: "Gold Label",
      QR_PRODUCT_TEMPLATE: "Products",
      ADMIN_CATEGORY: "Categories",
      QR_NFC_ORDERS: "NFC Cards Awaiting Approval",
      QR_NAME_PRODUCT: "Edit Product Introduction",
      QR_NAME_LABELPRODUCT: "Edit Product Label",
      QR_NAME_GOLDPRODUCT: "Edit Gold Label",
      QR_COINS: "Cryptocurrencies",
      QR_SHOP: "Shop Management",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "Upload Center",
      PRICING: "QR Tariffs",
      QR_CREATE_MODELS: "Create Business Card Model",
      QR_CREATE_BUSINESS_MODELS: "Create Business Page Model",
      QR_CREATE_PRODUCT_MODEL: "Create Product Card Model",
      QR_CREATE_MENU_MODELS: "Create Shop Menu Model",
      QR_CREATE_SHOP_MODEL: "Create Online Shop Model",
      MODELS_LIST: "QR Model Types",
      MODELS_LIST_EDIT: "Edit Model",
      MODELS_LIST_MENU_EDIT: "Edit Menu Model",
      MODELS_LIST_BMODEL_EDIT: "Edit Online Shop Model",
      NFC: "NFC Cards",
      SUBMIT_FORM: "Register Blogger",
      REQUEST_LIST: "Blogger List",
      PURE_DATA: "Uncreated Business Card List",
      AUTO_CREATE: "Automatic QR Creation",
      QR_CREATE: "Create QR",
      HISTORY_REMINDER: "Reminder Monitoring",
      BOOK: "Reminder Monitoring",
    },
  },
  qr_management: "QR Management",
  router: {
    dashboard: "Dashboard",
    contacts: "Customer Club",
    editContact: "Edit Customer",
    createContact: "Create Customer",
    customers: "Customer List",
    contactList: "Contact Assistant",
    messages: "Messages",
    messageCategories: "Message Categories",
    oldTransactions: "Old Transactions",
    yourTransactions: "Your Transactions",
    buyPanel: "Purchase Panel",
    permissions: "Permissions",
    createPermission: "Create Permission",
    invitations: "My Invitation List",
    editUser: "Edit User",
    userInformation: "View User Information",
    walletEdit: "Edit User Wallet Information",
    userHistory: "User History",
    userNotificationsHistory: "User Notification History",
    notifications: "Notifications",
    createNotification: "Create Notification",
    editNotification: "Edit Notification",
    adminNotifications: "Admin Notifications",
    yourNotifications: "Your Notifications",
    adminNotificationsList: "Admin Notifications",
    tickets: "Tickets",
    createTicket: "Register New Ticket",
    editTicket: "Edit Ticket",
    departments: "Departments",
    createDepartment: "New Department",
    editDepartment: "Edit Department",
    adminTickets: "Ticket Management",
    discounts: "Discounts",
    createDiscount: "Create Discount",
    editDiscount: "Edit Discount",
    workReports: "Work Reports",
    createWorkReport: "Create Work Report",
    callMonitoring: "Call Monitoring",
    adminWorkReports: "Work Reports Management",
    editWorkReport: "View and Edit Work Report",
    packProperties: "Package Features",
    createPackProperty: "Create Package Feature",
    editPackProperty: "Edit Package Feature",
    panels: "Panels",
    createPanel: "Create Panel",
    editPanel: "Edit Panel",
    transferRequests: "Withdrawal Requests",
    editTransferRequest: "Edit Withdrawal Request",
    tariffs: "Tariffs",
    createTariff: "Create Tariff",
    editTariff: "Edit Tariff",
    requests: "Requests",
    viewUser: "View User",
    manageTransactions: "Manage Transactions",
    viewTransaction: "View Transaction",
    manageConfigs: "Manage Settings",
    rbLandConfigs: "Manage Robot Land Settings",
    editConfig: "Edit Settings",
    manageUsers: "Manage Users",
    categories: "Categories",
    createCategory: "Add Category",
    editCategory: "Edit Category",
    content: "Content",
    createContent: "Add Content",
    editContent: "Edit Content",
    addUserGuide: "Add User Guide",
    editUserGuide: "Edit User Guide",
    roles: "Roles",
    editRole: "Edit Role",
    createRole: "Add Role",
    permissionTitle: "Permissions",
    paymentGateways: "Payment Gateways",
    editPaymentGateway: "Edit Payment Gateways",
    campaigns: "Campaigns",
    createCampaign: "Create Campaign",
    editCampaign: "Edit Campaign Information",
    adminCustomers: "Customers",
    createCustomer: "Create Customers",
    editCustomerInfo: "Edit Customer Information",
    referrerCustomers: "Referrer Customers",
    customerHistory: "Customer History",
    userProfile: "User Profile",
    editProfile: "Edit Profile",
    inviteFriends: "Invite Friends",
    personalInfo: "Personal Information",
    editPersonalInfo: "Edit Information",
    changePassword: "Change Password",
    newWallet: "New Wallet",
  },
  ticket: {
    text: "Register Ticket",
  },
};
